<template>
  <div class="wrapper">
    <div class="boxes" :class="{ boxes2: oushu }">
      <div
        class="box"
        v-for="(item, index) in images"
        @click="changeStatus"
        :key="index"
      >
        <img class="box-img" :src="`${fileServerUrl + item}`" />
        <!--                {{index}}-->
      </div>
    </div>
  </div>
</template>

<script>
import anime from "animejs/lib/anime.js";
import th from "element-ui/src/locale/lang/th";

export default {
  props: ["images", "duration", "direction", "oushu"],
  mounted() {
    var length = this.images.length; //有多少张图片
    var width = 242; //每个图片间隔
    var xWidth = length * width; //总宽度
    var duration = this.duration ? this.duration : 23000; //循环一周的时间
    var direction = this.direction && this.direction == "right" ? "+=" : "-="; //向右或者左滚动
    var xTrans = [];

    let myAnime = anime;

    myAnime.set(".box", {
      translateX: function (el, i, l) {
        xTrans[i] = { x: i * width };
        return i * width;
      },
    });

    myAnime({
      targets: xTrans,
      duration: duration, //走一周持续时间
      easing: "linear",
      x: direction + xWidth,
      loop: true,
      update: function (anim) {
        anime.set(".box", {
          translateX: function (el, i, l) {
            return xTrans[i].x % xWidth;
          },
        });
      },
    });
  },
  data() {
    return {
      fileServerUrl: fileServerUrl,
      anime: null,
    };
  },
  methods: {
    changeStatus() {
      // if (this.anime.paused){
      //     this.anime.play();
      // }else {
      //     this.anime.pause();
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 40px;
  padding: 1px 0;
  position: relative;
  overflow: hidden;
}

.box {
  width: 80px;
  height: 28px;
  position: absolute;
  background: white;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04), 0 0 6px rgba(0, 0, 0, 0.04);
  //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.box-img {
  width: 63px;
  height: 33px;

  //border: 0.1px solid darkorange;
}

//.box:nth-child(odd) {
//    background: #f8f8f8;
//}
//
//.box:nth-child(even) {
//    background: #eee;
//}

.boxes {
  position: relative;
  left: -100px;
}

.boxes2 {
  position: relative;
  left: -160px;
}
</style>
